import Activity from '@/models/Activity';
import AssetCategory from '@/models/AssetCategory';
import AssetStatus from '@/models/AssetStatus';
import BusinessHourContract from '@/models/BusinessHourContract';
import Category from '@/models/Category';
import Config from '@/models/Config';
import ContractPeriod from '@/models/ContractPeriod';
import CustomField from '@/models/CustomField';
import Operator from '@/models/Operator';
import PrepaidCard from '@/models/PrepaidCard';
import Priority from '@/models/Priority';
import Product from '@/models/Product';
import Role from '@/models/Role';
import Service from '@/models/Service';
import Sla from '@/models/Sla';
import TablePreset from '@/models/TablePreset';
import TicketSource from '@/models/TicketSource';
import TicketStatus from '@/models/TicketStatus';
import TicketType from '@/models/TicketType';

export default {
    SET_ACTIVITIES (state, payload) {
        state.activities = {};
        for (const key in payload) {
            state.activities[payload[key].id] = new Activity(payload[key]);
        }
    },
    SET_ASSETCATEGORIES (state, payload) {
        state.assetCategories = {};
        for (const key in payload) {
            state.assetCategories[payload[key].id] = new AssetCategory(payload[key]);
        }
    },
    SET_ASSETSTATUSES (state, payload) {
        state.assetStatuses = {};
        for (const key in payload) {
            state.assetStatuses[payload[key].id] = new AssetStatus(payload[key]);
        }
    },
    SET_BUSINESSHOURCONTRACTS (state, payload) {
        state.businessHourContracts = {};
        for (const key in payload) {
            const contractId = payload[key].id;

            // Ensure the object exists before setting properties
            if (!state.businessHourContracts[contractId]) {
                state.businessHourContracts[contractId] = {}; // Initialize the object
            }

            state.businessHourContracts[contractId].businessHours = new BusinessHourContract(payload[key]);
        }
    },
    SET_CATEGORIES (state, payload) {
        state.categories = {};
        for (const key in payload) {
            state.categories[payload[key].id] = new Category(payload[key]);
        }
    },
    SET_CLOUDDISTRIBUTORS (state, payload) {
        // not used by the portal but required for vuex due to our dynamic store creation
    },
    SET_COCKPITWIDGETS (state, payload) {
        // not used by the portal but required for vuex due to our dynamic store creation
    },
    SET_DEALSTAGES (state, payload) {
        // not used by the portal but required for vuex due to our dynamic store creation
    },
    SET_TICKETTEMPLATES (state, payload) {
        // not used by the portal but required for vuex due to our dynamic store creation
    },
    SET_MESSAGETEMPLATES (state, payload) {
        // not used by the portal but required for vuex due to our dynamic store creation
    },
    SET_NOTIFICATIONTYPES (state, payload) {
        // not used by the portal but required for vuex due to our dynamic store creation
    },
    SET_NOTIFICATIONCHANNELS (state, payload) {
        // not used by the portal but required for vuex due to our dynamic store creation
    },
    SET_OPERATORS (state, payload) {
        state.operators = {};
        for (const key in payload) {
            state.operators[payload[key].id] = new Operator(payload[key]);
        }
    },
    SET_OPERATORTYPES (state, payload) {
        state.operatorTypes = {};
        for (const key in payload) {
            state.operatorTypes[key] = key;
        }
    },
    SET_CONFIGS (state, payload) {
        for (const key in payload) {
            if (payload.input_type === 'json') {
                payload.value = JSON.parse(payload.value);
            }

            state.configs[payload[key].name] = new Config(payload[key]);
        }
    },
    SET_CONTRACTPERIODS (state, payload) {
        state.contractPeriods = {};
        for (const key in payload) {
            state.contractPeriods[payload[key].id] = new ContractPeriod(payload[key]);
        }
    },
    SET_SUBSCRIPTIONPERIODS (state, payload) {
        state.subscriptionPeriods = {};
        for (const key in payload) {
            state.subscriptionPeriods[payload[key].id] = payload[key];
        }
    },
    SET_COUNTRIES (state, payload) {
        state.countries = {};
        for (const key in payload) {
            state.countries[payload[key].id] = payload[key];
        }
    },
    SET_CUSTOMFIELDS (state, payload) {
        state.customFields = {};
        for (const key in payload) {
            state.customFields[payload[key].name] = new CustomField(payload[key]);
        }
    },
    SET_PREPAIDCARDS (state, payload) {
        state.prepaidCards = {};
        for (const key in payload) {
            state.prepaidCards[payload[key].id] = new PrepaidCard(payload[key]);
        }
    },
    SET_PERMISSIONS (state, payload) {
        for (const key in payload) {
            state.permissions[payload[key].id] = payload[key];
        }
    },
    SET_PRIORITIES (state, payload) {
        state.priorities = {};
        for (const key in payload) {
            state.priorities[payload[key].id] = new Priority(payload[key]);
        }
    },
    SET_PRODUCTS (state, payload) {
        state.products = {};
        for (const key in payload) {
            state.products[payload[key].id] = new Product(payload[key]);
        }
    },
    SET_ROLESOPERATOR (state, payload) {
        state.rolesOperator = {};
        for (const key in payload) {
            state.rolesOperator[payload[key].name] = new Role(payload[key]);
        }
    },
    SET_ROLESCLIENT (state, payload) {
        state.rolesClient = {};
        for (const key in payload) {
            state.rolesClient[payload[key].name] = new Role(payload[key]);
        }
    },
    SET_SERVICES (state, payload) {
        state.services = {};
        for (const key in payload) {
            state.services[payload[key].id] = new Service(payload[key]);
        }
    },
    SET_SLAS (state, payload) {
        state.slas = {};
        for (const key in payload) {
            state.slas[payload[key].id] = new Sla(payload[key]);
        }
    },
    SET_TICKETSTATUSES (state, payload) {
        state.ticketStatuses = {};
        for (const key in payload) {
            state.ticketStatuses[payload[key].id] = new TicketStatus(payload[key]);
        }
    },
    SET_TICKETSOURCES (state, payload) {
        state.ticketSources = {};
        for (const key in payload) {
            state.ticketSources[payload[key].id] = new TicketSource(payload[key]);
        }
    },
    SET_TICKETTYPES (state, payload) {
        state.ticketTypes = {};
        for (const key in payload) {
            state.ticketTypes[payload[key].id] = new TicketType(payload[key]);
        }
    },
    SET_TABLEPRESETS (state, payload) {
        state.tablePresets = {};
        for (const key in payload) {
            state.tablePresets[payload[key].id] = new TablePreset(payload[key]);
        }
    },
    SET_USER (state, payload) {
        state.user = payload;
    },
    SET_SYSTEM_STATUS (state, payload) {
        state.systemStatus = payload;
    },
    SET_SUBDOMAIN (state, payload) {
        state.subdomain = payload;
    },
    SET_BASE_URL (state, payload) {
        state.baseUrl = payload;
    },
    SET_HOSTNAME (state, payload) {
        state.hostname = payload;
    },
    UPDATE_CONFIG (state, payload) {
        state.configs[payload.name].value = payload.value;
    },
    UPDATE_USER_CONFIG (state, payload) {
        payload.forEach((config) => {
            state.user.configs[config.name] = config;
        });
    },
    UPDATE_CUSTOM_FIELD (state, payload) {
        state.customFields[payload.name] = payload;
    },
    REMOVE_CUSTOM_FIELD (state, name) {
        delete state.customFields[name];
    },
    UPDATE_STATUS (state, payload) {
        state.statuses[payload.id] = payload;
    },
    REMOVE_STATUS (state, id) {
        delete state.statuses[id];
    },
    UPDATE_TICKET_TYPE (state, payload) {
        state.ticketTypes[payload.id] = payload;
    },
    REMOVE_TICKET_TYPE (state, id) {
        delete state.ticketTypes[id];
    },
    UPDATE_CATEGORY (state, payload) {
        state.categories[payload.id] = payload;
    },
    REMOVE_CATEGORY (state, id) {
        delete state.categories[id];
    },
    UPDATE_ASSET_CATEGORY (state, payload) {
        state.assetCategories[payload.id] = payload;
    },
    REMOVE_ASSET_CATEGORY (state, id) {
        delete state.assetCategories[id];
    },
    UPDATE_TICKET_SOURCE (state, payload) {
        state.ticketSources[payload.id] = payload;
    },
    REMOVE_TICKET_SOURCE (state, id) {
        delete state.ticketSources[id];
    },
    UPDATE_BUSINESS_HOUR_CONTRACT (state, payload) {
        state.businessHourContracts[payload.id] = payload;
    },
    REMOVE_BUSINESS_HOUR_CONTRACT (state, id) {
        delete state.businessHourContracts[id];
    },
    UPDATE_PRIORITY (state, payload) {
        state.priorities[payload.id] = payload;
    },
    REMOVE_PRIORITY (state, id) {
        delete state.priorities[id];
    },
    UPDATE_PREPAID_CARD (state, payload) {
        state.prepaidCards[payload.id] = payload;
    },
    REMOVE_PREPAID_CARD (state, id) {
        delete state.prepaidCards[id];
    },
    UPDATE_TABLE_PRESET (state, payload) {
        state.tablePresets[payload.id] = payload;
    },
    REMOVE_TABLE_PRESET (state, id) {
        delete state.tablePresets[id];
    },
    UPDATE_OPERATOR (state, payload) {
        state.operators[payload.id] = payload;
    },
    REMOVE_OPERATOR (state, id) {
        delete state.operators[id];
    },
    UPDATE_ROLE (state, payload) {
        state.rolesOperator[payload.id] = payload;
        state.rolesClient[payload.id] = payload;
    },
    REMOVE_ROLE (state, id) {
        delete state.rolesOperator[id];
        delete state.rolesClient[id];
    },
};
